import { initialState } from './initialState';
import { appendPage, createReducer, dataAs, requestCases } from './requestState';

const surveyCases = requestCases('GET_SURVAYS', {
  loading: action => ({ surveyRequestId: action.meta && action.meta.requestId }),
  success: appendPage('userData', 'totalAvailableSurveys'),
});

// Promise middleware preserves meta on both outcomes. Ignore superseded requests before they
// can append an old page or clear the current request's loading/error flags.
const currentSurveyRequest = handler => (state, action) =>
  (action.meta && action.meta.requestId) === state.surveyRequestId ? handler(state, action) : state;

export default createReducer(initialState, {
  ...requestCases('AUTH_VERIFY', {
    success: action => ({ auth_verify: action.payload && action.payload.data, icons: [] }),
  }),
  GET_SURVAYS_LOADING: surveyCases.GET_SURVAYS_LOADING,
  GET_SURVAYS_SUCCESS: currentSurveyRequest(surveyCases.GET_SURVAYS_SUCCESS),
  GET_SURVAYS_ERROR: currentSurveyRequest(surveyCases.GET_SURVAYS_ERROR),
  ...requestCases('GET_PROFILE', { success: dataAs('get_profile') }),
  ...requestCases('EMAIL_CONFIRM', { success: dataAs('email_confirm') }),
  ...requestCases('CLOSE_ACCOUNT', { success: dataAs('close_account') }),
  ...requestCases('SAR_GDPR', { success: dataAs('sar_gdpr') }),
  ...requestCases('EMAIL_CHANGE', { success: dataAs('email_change') }),
  ...requestCases('GDPR_RECORD', { success: dataAs('gdpr_change') }),
  ...requestCases('LOGIN_HISTORY', { success: dataAs('loginHistoryData') }),

  RESET_AVAILABLE_SURVEYS: state => ({
    ...state,
    surveyRequestId: null,
    isLoading: false,
    error: false,
    userData: [],
    totalAvailableSurveys: null,
  }),

  NEW_APP_VERSION: (state, action) => ({
    ...state,
    newAppVersion: action.payload,
  }),
});
